import "./RoadmapKey.css";

import { ColorConstants } from "../../../../../constants";

export const RoadmapKey = (): JSX.Element => {
  return (
    <div className="RoadmapKey">
      <h3>Key</h3>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_500 }} />
        <p>Feasibility</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.CORAL_500 }} />
        <p>Design</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.AQUA_500 }} />
        <p>Implementation</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_500 }} />
        <p>Ongoing monitoring</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.BLUE_200 }} />
        <p>Today</p>
      </div>
    </div>
  );
};
